export const nullDate = (dt: any) => {
    return dt ? dt.toDate() : null;
}